import {
  ArrowDownToSquare,
  ChartAreaStackedNormalized,
  LogoTelegram,
} from "@gravity-ui/icons";
import { trackEvent } from "src/util/analytics";

export enum SlideIdType {
  EXPORTER,
  TELEGRAM,
  BALANCE,
}

export interface ModalSlideType {
  id: SlideIdType;
  title: string;
  text: string;
}

export const slidesButton = [
  {
    title: "Выгрузки",
    href: "/lk/export",
    blank: false,
    onClick: () => {
      trackEvent("welcome-modal-exporter");
    },
    icon: ArrowDownToSquare,
  },
  {
    title: "Подписаться",
    href: "https://t.me/PoizonAPI",
    blank: true,
    onClick: () => {
      trackEvent("welcome-modal-to-tg");
    },
    icon: LogoTelegram,
  },
  {
    title: "Подписки",
    href: "/lk/subscribe",
    blank: false,
    onClick: () => {
      trackEvent("welcome-modal-to-payment");
    },
    icon: ChartAreaStackedNormalized,
  },
];

export const MODAL_SLIDES: ModalSlideType[] = [
  {
    id: 0,
    title: "Выгрузка товаров с Poizon",
    text: "Мы предлагаем удобный инструмент для выгрузки товаров с Poizon. Хотите получить данные в JSON? Или вам нужен готовый шаблон для вашего интернет-магазина, например WooCommerce?",
  },
  {
    id: 1,
    title: "Наш Telegram",
    text: "Присоединяйтесь к нашему Telegram-каналу, где мы регулярно публикуем свежие новости, важные обновления и эксклюзивные материалы. Не пропустите самое главное — подпишитесь сейчас!",
  },
  {
    id: 2,
    title: "Приобретение подписки",
    text: "Приобретите подписку и откройте для себя все возможности нашего сервиса. Это ваш первый шаг к удобству и новым возможностям. Начните пользоваться всеми преимуществами уже сегодня!",
  },
];

export const SWIPER_SLIDE_CHANGE_SPEED = 500;

export const RELEASE_DATE = new Date(
  "Mon Aug 27 2024 14:00:00 GMT+0300 (Москва, стандартное время)",
).getTime();
